import { Controller } from "@hotwired/stimulus"

const DETAILS_TYPES = ['act', 'break', 'effective', 'over', 'night', 'hol']

// Connects to data-controller="performances--column-toggle"
export default class extends Controller {
  static values = {
    storageKey: { type: String, default: 'performances-toggle-states' }
  }

  connect() {
    this.restore()
  }

  toggleAttendanceDetails(event) {
    const show = event.target.checked
    this.applyVisibility(show)
    this.save(show)
  }

  restore() {
    const states = this.getToggleStates()
    const detailsChecked = states.attendanceDetails ?? false
    const detailsCheckbox = document.getElementById('toggleAttendanceDetails')
    if (detailsCheckbox) detailsCheckbox.checked = detailsChecked

    this.applyVisibility(detailsChecked)
  }

  applyVisibility(show) {
    document
      .querySelector('.col-attendance-details')
      ?.classList.toggle('hide-col', !show)

    DETAILS_TYPES.forEach(type => {
      document
        .querySelectorAll(`.th-${type}, .td-${type}, .col-${type}`)
        .forEach(el => el.classList.toggle('hide-col', !show))
    })
  }

  save(show) {
    const states = this.getToggleStates()
    states.attendanceDetails = show
    sessionStorage.setItem(this.storageKeyValue, JSON.stringify(states))
  }

  getToggleStates() {
    const saved = sessionStorage.getItem(this.storageKeyValue)
    return saved ? JSON.parse(saved) : {}
  }

  clearStates() {
    sessionStorage.removeItem(this.storageKeyValue)
  }
}
